import { Grid } from '@material-ui/core';
import React from 'react';
import { useGtXs } from '../../hooks/useGtXs';
import OutlineButton from '../OutlineButton/OutlineButton';
import Paragraph from '../Paragraph/Paragraph';
import Typography from '../Typography/Typography';
import styles from './AlchemyView.module.scss';

const Title = () => {

    const gtXs = useGtXs()
    const titleVariant = gtXs ? "ColisseumRegular58" : "ColisseumRegular48"
    const subtitleVariant = gtXs ? "ColisseumRegular38" : "ColisseumRegular34"

    return (
        <div className={styles.Title}>
            <Typography variant={titleVariant} paragraph>
                Alquimia
            </Typography>
            <Typography variant={subtitleVariant} paragraph className={styles.Subtitle}>
                Transformação pela Arte
            </Typography>
        </div >
    )
}

const Introduction = () => {

    const gtXs = useGtXs()
    const variant = gtXs ? "RocGroteskMedium20" : "RocGroteskMedium25"

    return (
        <div className={styles.Introduction}>
            <Paragraph variant={variant} className={styles.First}>
                O Serviço Educativo Coliseu lança Alquimia, um ambicioso projeto social e cultural, a ter lugar anualmente entre 2025 e 2027.
            </Paragraph>
            <Paragraph variant={variant} className={styles.Second}>
                Direcionado à população com mais de 65 anos que habita ou frequenta a União de Freguesias do Centro Histórico do Porto (Cedofeita, Santo Ildefonso,
                Sé, Miragaia, São Nicolau e Vitória), geografia onde o Coliseu se insere, haverá oficinas artísticas, visitas culturais, espaços de partilha e um Coro
                Comunitário - este aberto a pessoas de todas as idades.
            </Paragraph>

        </div>
    )
}

const Description = () => {

    const gtXs = useGtXs()
    const variant = gtXs ? "RocGroteskMedium20" : "RocGroteskMedium25"

    return (
        <div className={styles.Description}>
            <Paragraph variant={variant} className={styles.First}>
                Ao longo de 10 meses, os participantes têm acesso a diversas atividades gratuitas, como oficinas de música, teatro, dança/movimento, desenho/pintura,
                escrita criativa, podcast filosófico, fotografia e vídeo, assim como visitas culturais, encontros e momentos de partilha, um coro comunitário, mostra
                e exposições, partilha de experiências e momentos de convívio.
            </Paragraph>
            <Paragraph variant={variant} className={styles.Second}>
                Coordenado por uma equipa de artistas e educadores, o objetivo é combater o isolamento crescente no centro histórico, desenvolver o sentimento de comunidade,
                promover o acesso à cultura e às artes, e partilhar conhecimentos, valorizando os ensinamentos que os participantes trazem para o projeto.
            </Paragraph>
        </div>
    )
}


const TargetAudience = () => {
    return (
        <div className={styles.TargetAudience}>
            <Typography variant="ColisseumRegular30" component="h3">
                Público-Alvo
            </Typography>
            <Paragraph variant="RocGroteskRegular16">
                Direcionado à população com mais de 65 anos que habita ou frequenta a União de Freguesias do Centro Histórico do Porto (Cedofeita, Santo Ildefonso,
                Sé, Miragaia, São Nicolau e Vitória)
            </Paragraph>
        </div>
    )
}


const AdditionalInfo = () => {

    return (
        <div className={styles.AdditionalInfo}>
            <Typography variant="ColisseumRegular30" component="h3">
                Informações Adicionais
            </Typography>

            <div className={styles.AdditionalInfoContent}>
                <Paragraph variant="RocGroteskRegular16">
                    A participação é gratuita e as inscrições encontram-se abertas online, em <a href="https://www.alquimiacoliseu.com" target="_blank" rel="noopener noreferrer">www.alquimiacoliseu.com</a>
                    &nbsp; assim como através do e-mail &nbsp;
                    <a href="mailto:alquimia@coliseu.pt">alquimia@coliseu.pt</a>&nbsp;
                    ou do telefone &nbsp;
                    <a href="tel:223395092">223 395 092</a>
                </Paragraph>
            </div>
        </div>
    )
}

const Banner = () => {
    return (
        <div className={styles.Banner}>
            <div className={styles.Photo} />
        </div>
    )
}

const Logos = () => {
    return (
        <div className={styles.Logos}>
            <div className={styles.Brands} />
        </div>
    )
}

const CallToAction = () => {
    return (
        <OutlineButton route="https://alquimiacoliseu.com" name="alquimiacoliseu.com" />
    )
}

export default function AlchemyView() {

    const gtXs = useGtXs()

    return (
        <div>
            <div className={styles.SectionBanner} />
            <Grid container justify="center" className={styles.Wrapper}>
                <main>

                    {gtXs ?

                        <Grid container spacing={10}>

                            <Grid item xs={5}>
                                <div style={{ marginBottom: 50 }}>
                                    <CallToAction />
                                </div>
                                <TargetAudience />
                                <AdditionalInfo />
                            </Grid>

                            <Grid item xs={7}>
                                <Title />
                                <Introduction />
                                <Banner />
                                <Description />
                                <div style={{ maxWidth: 300 }}>
                                    <CallToAction />
                                </div>
                                <Logos />
                            </Grid>

                        </Grid>

                        :

                        <Grid container justify="space-between" className={styles.Presentation}>
                            <Grid item xs={12}>
                                <Title />
                                <div style={{ marginTop: 30, marginBottom: 30 }}>
                                    <CallToAction />
                                </div>
                                <TargetAudience />
                                <AdditionalInfo />

                                <Introduction />
                                <Banner />
                                <Description />
                                <Logos />
                            </Grid>
                        </Grid>
                    }
                </main>

            </Grid >
        </div >
    )
}
